import {Action} from '@reduxjs/toolkit';

/**
 * Utility to create parametrized selectors with createSelector
 */
export const withArgument = <T>(_: AppModel, arg: T) => arg;

/**
 * Utility to create typed actions with createAction
 */
export const withPayload = <T>(payload: T) => ({payload});

export const onlyLeading =
    <A extends Action>(effectFn: (action: A, api: AppEffectAPI) => void | Promise<void>) =>
    async (action: A, api: AppEffectAPI) => {
        try {
            api.unsubscribe();
            await effectFn(action, api);
        } finally {
            api.subscribe();
        }
    };

export const withInitialState = <S, A>(reducer: (state: S, action: A) => S, getInitialState: S | (() => S)) => {
    if (!(getInitialState instanceof Function)) {
        const initialState = getInitialState;
        getInitialState = () => initialState;
    }
    return (state: S = getInitialState(), action: A) => reducer(state, action);
};
